module.exports = __webpack_public_path__ + "img/en.2041ee46.png";